webpackJsonp([19],{

/***/ "Axs9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"coinbase-process-overview",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 1\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n       We initiate a "+_vm._s(_vm.amountDisplay)+" USDC transaction with Coinbase, a leader in digital payment solutions.\n    ")])]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 2\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n       You are automatically redirected to the Coinbase payment details website where you can see all of the necessary details about your future "+_vm._s(_vm.amountDisplay)+" USDC transaction. "),_c('strong',[_vm._v("Only send USD Coin (USDC), sending any other digital asset, including Ethereum (ETH) will result in permanent loss.")])])]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 3\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n       Using Coinbase, or your preferred digital payment wallet, you send us the payment using the unique payment details from Step 2."),_c('strong',[_vm._v(" Please Note: While you are technically able to send more or less than the amount you entered on the previous screen ($"+_vm._s(_vm.amountDisplay)+") using your wallet, doing so will result in significant delays in your payment processing.")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"column small-1"},[_c('form-checkbox',{staticClass:"checkbox--no-margin",attrs:{"name":"Afree","label":""},model:{value:(_vm.fields.agreed),callback:function ($$v) {_vm.$set(_vm.fields, "agreed", $$v)},expression:"fields.agreed"}})],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"add-funds-coinbase__submit"},[_c('form-submit',{attrs:{"label":"Continue to Coinbase","disabled":_vm.isConfirmDisabled}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 4\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n      While your deposit is being processed by the crypto processing network it will not appear in your PredictIt account balance. Once the payment has been verified by Coinbase your PredictIt account balance will automatically be updated. Depending on network traffic this can take up to 24hrs.\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-11"},[_c('div',{staticClass:"coinbase-process-overview__note"},[_vm._v("\n          I understand the risks of using crypto currencies and that any over-payments can only be 'refunded' via the standard PredictIt Withdrawal process and are subject to standard processing fees.\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MbhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_process_overview_js__ = __webpack_require__("b47U");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd60b24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_process_overview_vue__ = __webpack_require__("Axs9");
function injectStyle (ssrContext) {
  __webpack_require__("U8Te")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_process_overview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd60b24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_process_overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "U8Te":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dolA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("d63f0328", content, true, {});

/***/ }),

/***/ "b47U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__ = __webpack_require__("9xQS");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* formMixin */]],
  props: {
    depositPayload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      fields: {
        agreed: false
      }
    };
  },

  computed: {
    amountDisplay: function amountDisplay() {
      return Number(this.depositPayload.amount).toFixed(2);
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return !this.isFormEnabled || !this.fields.agreed;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['submitDepositUSDCoin']), {
    onSubmit: function onSubmit() {
      var _this = this;

      this.formDisable();
      this.loaderAdd(document.body);
      this.submitDepositUSDCoin(this.depositPayload).then(function (data) {
        _this.loaderRemove(document.body);
        if (_this.checkDocumentUploadFlags(data)) return;
        _this.formEnable();
        window.location.href = data.url;
      }).catch(function (error) {
        _this.loaderRemove(document.body);
        if (_this.checkDocumentUploadFlags(error.response.data)) return;
        _this.formEnable();
      });
    }
  })
});

/***/ }),

/***/ "dolA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}.coinbase-process-overview{padding-bottom:24px}.coinbase-process-overview__step{margin:16px 0}.coinbase-process-overview__step-title{font-size:16px;font-weight:700;text-transform:uppercase}.coinbase-process-overview__step-content{font-size:14px}.coinbase-process-overview__note{font-size:12px}@media (max-width:320px){.coinbase-process-overview__note{margin-left:5px}}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/components/wallet/coinbase-process-overview/coinbase-process-overview.scss"],"names":[],"mappings":"AACA,yBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AACD,iBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AAQD,2BACE,mBAAqB,CACtB,AACD,iCACI,aAAe,CAClB,AACD,uCACM,eAAgB,AAChB,gBAAkB,AAClB,wBAA0B,CAC/B,AACD,yCACM,cAAgB,CACrB,AACD,iCACI,cAAgB,CACnB,AACD,yBACA,iCACQ,eAAiB,CACxB,CACA","file":"coinbase-process-overview.scss","sourcesContent":["/* stylelint-disable at-rule-no-unknown */\n@-webkit-keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n@keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n\n/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n.coinbase-process-overview {\n  padding-bottom: 24px;\n}\n.coinbase-process-overview__step {\n    margin: 16px 0;\n}\n.coinbase-process-overview__step-title {\n      font-size: 16px;\n      font-weight: bold;\n      text-transform: uppercase;\n}\n.coinbase-process-overview__step-content {\n      font-size: 14px;\n}\n.coinbase-process-overview__note {\n    font-size: 12px;\n}\n@media (max-width: 320px) {\n.coinbase-process-overview__note {\n        margin-left: 5px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/19.d3011ac1093c5c8d22de.js